<div class="table-custom__box-buttons">
  <button class="table-custom__button"
          color="primary"
          mat-stroked-button
          (click)="showButtonsAction($event)">
    <mat-icon>info</mat-icon>
    Opções
  </button>
  <div class="table-custom__hidden table-custom__box-buttons-group p-2 animate__animated animate__fadeIn"
       fxLayout.xs="column">
    <button *ngFor="let item of buttons"
            class="table-custom__button w-100 mb-1"
            color="primary"
            mat-stroked-button
            matTooltipPosition="above"
            [disabled]="item.disabled ? item.disabled(itemDataSource) : false"
            [matTooltip]="item.tooltip ? item.tooltip : ''"
            (click)="item.onClick(itemDataSource, $event)">
      <span *ngIf="item.icon">
        <mat-icon>{{item.icon}}</mat-icon>
      </span>
      <span *ngIf="item.label">
        {{item.label}}
      </span>
    </button>
  </div>
</div>
